import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { AdBigbox, SiteSettings } from '@ratehub/web-components';


function RightSideBigAdContainer({ children, hasAd, className }) {
    return (
        <Container
            className={classNames(
                'rh-display-flex rh-flex-wrap rh-justify-content-space-between',
                className,
            )}
        >
            <div className="content-container rh-my-0 rh-mx-1_5 rh-max-width-800px">
                {children}
            </div>

            <If condition={hasAd}>
                <aside
                    className={`rh-display-flex rh-align-items-flex-start rh-justify-content-center
                        rh-py-0 rh-px-1_5 rh-mt-5 rh-mb-0 rh-mx-auto`}
                >
                    <AdBigbox alignment={AdBigbox.ALIGNMENTS.LEFT} />
                </aside>
            </If>
        </Container>
    );
}

RightSideBigAdContainer.propTypes = {
    children: PropTypes.node.isRequired,
    hasAd: PropTypes.bool,
    className: PropTypes.string,
};

RightSideBigAdContainer.defaultProps = {
    hasAd: false,
    className: undefined,
};


const Container = styled.section`
    margin: 0 -${SiteSettings.CHROME_BASE_PADDING};

    > .content-container {
        flex: 1 1 40em;
    }

    > aside {
        flex: 1 0 300px;      /* ad size: 300px x 250px */
    }
`;


export default RightSideBigAdContainer;
